module.exports = __webpack_public_path__ + "img/NORDIC_CAKES_AND_PASTRIES.d55d0abc.png";